module.exports = __webpack_public_path__ + "static/img/iconpaypal.cb383f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconpaypal.jpg
// module id = AQfa
// module chunks = 1